import gql from 'graphql-tag';

export const setOnboardingStateGQL = gql`
	mutation SetOnboardingState($states: [OnboardingStateInput!]!) {
		setOnboardingState(states: $states) {
			key
			value
		}
	}
`;
